/**
 * Partnerbook Market Icon System - witte tegel met een gevulde Material-stijl
 * glyph per Markt (eigenaarsbesluit 10 aug 2026, vervangt de isometrische set
 * van 12 jul 2026). Elke markt draagt een eigen vibrante solide kleur; de
 * record-bar-kleuren van het universele recordvenster (RECORD_TYPE_META in
 * components/HomeV2/lib.js) zijn bewust vermeden.
 *
 * ESM: import { marketIcon, MARKETS } from './partnerbook-icons.mjs'
 * Plain script: also attached to window.PartnerbookIcons.
 */

// Vibrante glyphkleuren + tegelneutralen. PALETTE blijft geexporteerd voor
// bestaande imports; de markt-hues staan per markt in MARKET_META.
export const PALETTE = {
  tile: '#ffffff',
  tileBorder: '#d5d5d5',
  slate: '#5b6472',   // fallback-glyph voor onbekende markten
  ink: '#1a1a1a',
};

// De ingebouwde canonieke Markten (order + spelling match market-infer.mjs).
export const MARKETS = ['Java', 'Data', 'Cloud', 'Testing', 'Architectuur', 'Finance', 'Controlling', 'Accounting', 'Sales', 'Contracting', 'Legacy', 'Security', 'Executive', 'Business Intelligence'];

// Gevulde 24x24-glyphs (Material-familie, zelfde stijl als de overige
// app-iconen maar filled). Front-facing, een pad per glyph.
export const GLYPHS = {
  cafe: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z',
  package: 'M12 2 3 6.5v11L12 22l9-4.5v-11L12 2zm0 2.2 6.6 3.3L12 10.8 5.4 7.5 12 4.2zM5 9.1l6 3v6.9l-6-3V9.1zm8 9.9v-6.9l6-3v6.9l-6 3z',
  monitor: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z',
  code: 'M9.4 16.6 4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0 4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z',
  database: 'M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4zm0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z',
  cloud: 'M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z',
  shield: 'M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z',
  flask: 'M19.8 18.4 14 10.67V6.5l1.35-1.69c.26-.33.03-.81-.39-.81H9.04c-.42 0-.65.48-.39.81L10 6.5v4.17L4.2 18.4c-.49.66-.02 1.6.8 1.6h14c.82 0 1.29-.94.8-1.6z',
  city: 'M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z',
  inventory: 'M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4h16v3z',
  memory: 'M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2z',
  cycle: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 0 1 6 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z',
  wrench: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z',
  bank: 'M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6l-10-4z',
  barchart: 'M5 9.2h3V19H5zm5.6-4.2h2.8v14h-2.8zm5.6 8H19v6h-2.8z',
  piechart: 'M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z',
  codebraces: 'M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7zm17 3h-1c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83v.34c-1.16.41-2 1.52-2 2.83v2c0 .55-.45 1-1 1h-3v2h3c1.65 0 3-1.35 3-3v-2c0-.55.45-1 1-1h1v-4z',
  robot: 'M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM7.5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5zM16 17H8v-2h8v2zm-.5-4c-.83 0-1.5-.67-1.5-1.5S14.67 10 15.5 10s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z',
  helmet: 'M12 3C7.03 3 3 7.03 3 12h18c0-4.97-4.03-9-9-9zM2 14h20v2H2zm2 4h16v2H4z',
  headset: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z',
  personadd: 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
  people: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z',
  clipboard: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z',
  trending: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z',
  document: 'M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z',
  server: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z',
  briefcase: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z',
  megaphone: 'M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z',
  lan: 'M13 22h8v-7h-3v-4h-5V9h3V2H8v7h3v2H6v4H3v7h8v-7H8v-2h8v2h-3v7z',
  palette: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z',
  smartphone: 'M17 1.01 7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-1.99zM17 19H7V5h10v14z',
  umbrella: 'M12 2C6.48 2 2 6.48 2 12h20c0-5.52-4.48-10-10-10zm1 10v7c0 1.66-1.34 3-3 3s-3-1.34-3-3H5c0 2.76 2.24 5 5 5s5-2.24 5-5v-7h-2z',
  house: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z',
  // Management (18 sep 2026): Material manage_accounts, persoon met tandwiel,
  // letterlijk uit google/material-design-icons. Het hoofd is daar een <circle>
  // en staat hier als pad in de vorm van personadd, zodat het een pad blijft.
  manageaccounts: 'M10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM10.67 13.02c-.22-.01-.44-.02-.67-.02-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26a6.963 6.963 0 0 1-.59-6.98zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z',
  // Executive (eigenaarskeuze 17 aug 2026): Staunton-schaakkoning, handgetekend
  // silhouet (kruis, kroon, kraag, taps stuk, voet, plint). Draagt shade: true
  // in MARKET_META, dus tile()/marketGlyph() leggen over de rechterhelft een
  // donkere laag voor een licht ruimtelijk effect.
  king: 'M11 .5h2v2.2h2.2v2h-2.2v1.4h-2V4.7H8.8v-2H11z M8 7.6c0-1.3 1.8-1.9 4-1.9s4 .6 4 1.9c0 1.3-1.3 2.5-2.4 3.1H10.4C9.3 10.1 8 8.9 8 7.6z M9.2 10.9h5.6v1.2H9.2z M10 12.3h4l1.3 4.9H8.7z M7.6 17.4h8.8c.6 0 1 .4 1 1v1H6.6v-1c0-.6.4-1 1-1z M5.5 19.7h13v1.4c0 .5-.4.9-.9.9H6.4c-.5 0-.9-.4-.9-.9z',
  // Research (eigenaarsbesluit): gevulde hertekening van de hub-met-zes-satellieten
  // uit components/HomeV2/MatchIcon.js (hub + zes bolletjes + zes verbindende
  // staafjes, samengevoegd tot een gevuld silhouet). MatchIcon.js blijft de
  // canonieke stroke-bron voor rail/zoekbalk/Research-pagina en de path-data
  // wordt daar bewust niet gekopieerd; dit is de losstaande gevulde variant voor
  // de Markten-tegel.
  research: 'M9 12 A3 3 0 1 0 15 12 A3 3 0 1 0 9 12 Z M12.5 9 L11.5 9 L11.5 5.6 L12.5 5.6 Z M9.9 3.5 A2.1 2.1 0 1 0 14.1 3.5 A2.1 2.1 0 1 0 9.9 3.5 Z M11.5 15 L12.5 15 L12.5 18.4 L11.5 18.4 Z M9.9 20.5 A2.1 2.1 0 1 0 14.1 20.5 A2.1 2.1 0 1 0 9.9 20.5 Z M9.65 10.07 L9.15 10.94 L6.17 9.23 L6.67 8.36 Z M2.5 7.75 A2.1 2.1 0 1 0 6.7 7.75 A2.1 2.1 0 1 0 2.5 7.75 Z M14.85 10.94 L14.35 10.07 L17.33 8.36 L17.83 9.23 Z M17.3 7.75 A2.1 2.1 0 1 0 21.5 7.75 A2.1 2.1 0 1 0 17.3 7.75 Z M9.15 13.06 L9.65 13.93 L6.67 15.64 L6.17 14.77 Z M2.5 16.25 A2.1 2.1 0 1 0 6.7 16.25 A2.1 2.1 0 1 0 2.5 16.25 Z M14.35 13.93 L14.85 13.06 L17.83 14.77 L17.33 15.64 Z M17.3 16.25 A2.1 2.1 0 1 0 21.5 16.25 A2.1 2.1 0 1 0 17.3 16.25 Z',
};

// Market -> { hue, glyph }. Elke markt een eigen vibrante solide kleur; de
// gedegradeerde specialismen houden hun regel zodat oude records met zo'n tag
// nog steeds een icoon krijgen (conservatieve degradatie).
export const MARKET_META = {
  'Java': { hue: '#E53935', glyph: 'cafe' },
  '.NET': { hue: '#512BD4', glyph: 'package' },
  'Front-end': { hue: '#2962FF', glyph: 'monitor' },
  'PHP': { hue: '#3F51B5', glyph: 'code' },
  'Data': { hue: '#00ACC1', glyph: 'database' },
  'AI': { hue: '#7C4DFF', glyph: 'robot' },
  // Artificial Intelligence (13 sep 2026): de officiele markt, 'AI' blijft als
  // gedegradeerde tag. Zelfde robotglyph, dieper paars dan Embedded (#7C4DFF).
  'Artificial Intelligence': { hue: '#6200EA', glyph: 'robot' },
  'Cloud': { hue: '#039BE5', glyph: 'cloud' },
  'Security': { hue: '#C62828', glyph: 'shield' },
  'Testing': { hue: '#43A047', glyph: 'flask' },
  'Architectuur': { hue: '#C51162', glyph: 'city' },
  'ERP': { hue: '#FB8C00', glyph: 'inventory' },
  'Embedded': { hue: '#7C4DFF', glyph: 'memory' },
  'Agile': { hue: '#7CB342', glyph: 'cycle' },
  'Techniek': { hue: '#F4511E', glyph: 'wrench' },
  'Finance': { hue: '#00875A', glyph: 'bank' },
  'Controlling': { hue: '#0277BD', glyph: 'barchart' },
  'Accounting': { hue: '#00695C', glyph: 'clipboard' },
  'Sales': { hue: '#FFB300', glyph: 'trending' },
  'Contracting': { hue: '#9E9D24', glyph: 'document' },
  'Legacy': { hue: '#BF360C', glyph: 'server' },
  'Executive': { hue: '#1A237E', glyph: 'king', shade: true },
  // Management (18 sep 2026): donkerbruin, de verste tint van alle bestaande
  // markten (CIEDE2000 minstens 16 tot elke hue hier). Bouw is het lichte bruin
  // met de helm, dus op kleur en vorm allebei te scheiden.
  'Management': { hue: '#5D4037', glyph: 'manageaccounts' },
  'Business Intelligence': { hue: '#00838F', glyph: 'piechart' },
  'Business Consulting': { hue: '#8E24AA', glyph: 'briefcase' },
  'Marketing': { hue: '#EC407A', glyph: 'megaphone' },
  'Netwerk & Infrastructuur': { hue: '#00BFA5', glyph: 'lan' },
  'Software Engineering': { hue: '#455A64', glyph: 'codebraces' },
  'Bouw': { hue: '#8D6E63', glyph: 'helmet' },
  'Werkplekbeheer': { hue: '#5C6BC0', glyph: 'headset' },
  // Verzekeringen en Vastgoed (30 aug 2026): schadebehandelaars, volmacht-
  // acceptanten en makelaars kwamen uit de &Work-scrape en vielen buiten elke
  // bestaande markt. Donkere tinten die niet botsen met de rode, groene en roze
  // markten die er al zijn; paraplu en huis zijn vormmatig uniek.
  'Verzekeringen': { hue: '#880E4F', glyph: 'umbrella' },
  'Vastgoed': { hue: '#33691E', glyph: 'house' },
  // Mobile (30 aug 2026): iOS- en Android-rollen werden tot nu toe in Software
  // Engineering geduwd. Diep indigo, donkerder dan .NET (#512BD4) en PHP
  // (#3F51B5); het telefoonglyph is vormmatig sowieso niet te verwarren.
  'Mobile': { hue: '#311B92', glyph: 'smartphone' },
  // Design (30 aug 2026): UX-, visual- en digital-designrollen hadden geen markt.
  // Vivide oranje, bewust los van ERP (#FB8C00) en Techniek (#F4511E) doordat het
  // paletglyph vormmatig al uniek is.
  'Design': { hue: '#FF6D00', glyph: 'palette' },
  // Research (Research Agent, geen recruitmentvertical): eigen gedempte
  // petrolkleur, los van de bestaande Data/Cloud-cyaantinten.
  'Research': { hue: '#1C6E77', glyph: 'research' },
  'Recruitment': { hue: '#78909C', glyph: 'personadd' },
  'HR': { hue: '#AD1457', glyph: 'people' },
};

// ── Industrieën (eigenaarsbesluit 13 sep 2026) ──────────────────────────────
// Dezelfde tegel als een markt-icoon, andere woordenlijst: dit zijn de sectoren
// waarin de KLANTEN van een bedrijf zitten, of waarin een kandidaat wil werken.
// Een eigen hue per label, want ze staan naast elkaar in een pilrij en moeten
// daar op vorm EN kleur uit elkaar te houden zijn. Zes glyphs komen uit GLYPHS:
// een tweede paraplu of bank tekenen zou dezelfde vorm twee keer onderhouden.
//
// Twee glyphs dragen een tweede kleur en zijn daarom een LAGENLIJST in plaats
// van een pad: het rode kruis op het donkere schild (defensie) en de drie munten
// met hun valutatekens (finance). Een laag is { d, fill } met fill 'hue' voor de
// industriekleur, of een streeklaag { d, stroke, sw }: de tekens € $ ¥ zijn
// lijnen, geen vlakken, en als vulpad zouden ze op 14px dichtslibben.
const COIN = (cx, cy, r) => `M${cx - r} ${cy}a${r} ${r} 0 1 0 ${r * 2} 0a${r} ${r} 0 1 0 ${-r * 2} 0Z`;

export const INDUSTRY_GLYPHS = {
  // Drie munten in de tegel: de bovenste eerst, daarna per onderste munt een
  // iets grotere witte cirkel als scheiding en dan de munt zelf. Zo ontstaat de
  // gleuf tussen de munten zonder een tweede kleur of een streek.
  coins3: [
    { d: COIN(12, 8.4, 5.1), fill: 'hue' },
    { d: COIN(7.5, 15.6, 5.55), fill: '#ffffff' },
    { d: COIN(7.5, 15.6, 5.1), fill: 'hue' },
    { d: COIN(16.5, 15.6, 5.55), fill: '#ffffff' },
    { d: COIN(16.5, 15.6, 5.1), fill: 'hue' },
    // € op de bovenste munt, $ linksonder, ¥ rechtsonder. Geen teksttekens in de
    // SVG: een <text> hangt aan het lettertype van de lezer en een data-URI in
    // een <img> heeft dat lettertype niet.
    {
      d: 'M14.11 6.63A2.75 2.75 0 1 0 14.11 10.17M8.9 7.5h4M8.9 9.3h4'
        + 'M9 13.7C5.1 13 5.1 15.2 7.5 15.6C9.9 16 9.9 18.2 6 17.5M7.5 12.7v5.8'
        + 'M14.7 13.3 16.5 15.7 18.3 13.3M16.5 15.7v2.4M14.9 16.5h3.2M14.9 17.6h3.2',
      stroke: '#ffffff',
      sw: 1.1,
    },
  ],
  umbrella: GLYPHS.umbrella,
  hospital: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z',
  medication: 'M6 3h12v2H6zm11 3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-1.5 10h-2v2h-3v-2h-2v-3h2v-2h3v2h2v3z',
  bank: GLYPHS.bank,
  // Het schild draagt de industriekleur, het kruis blijft altijd rood: dat is
  // het teken zelf, geen accent van de tegel.
  shieldcross: [
    { d: GLYPHS.shield, fill: 'hue' },
    { d: 'M10.6 6.5h2.8v3.6H17v2.8h-3.6v5.2h-2.8v-5.2H7v-2.8h3.6z', fill: '#E53935' },
  ],
  bolt: 'M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z',
  truck: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9 1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z',
  flight: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z',
  boat: 'M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z',
  car: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z',
  factory: 'M22 22H2V10l7-3v2l5-2v3h3l1-8h3l1 8v12zM12 9.95l-5 2V10l-3 1.32V20h16v-8h-8V9.95zM11 18h2v-4h-2v4zm-4 0h2v-4H7v4zm10-4h-2v4h2v-4z',
  memory: GLYPHS.memory,
  cart: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z',
  apartment: 'M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z',
  school: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3 1 9l11 6 9-4.91V17h2V9L12 3z',
  celltower: 'M7.3 14.7l1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s.7 3.4 2 4.7zm11.8-11.8-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9 0 2.1-.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1 0-2.6-1-5.1-2.9-7.1zM6.1 4.1 4.9 2.9C2.9 4.9 2 7.4 2 10c0 2.6 1 5.1 2.9 7.1l1.2-1.2C4.5 14.3 3.7 12.1 3.7 10c0-2.1.8-4.3 2.4-5.9zm10.6 1.2-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-.5 2.6-1.5 3.5l1.2 1.2c1.3-1.3 2-3 2-4.7 0-1.7-.7-3.4-2-4.7zM14.5 10c0-1.4-1.1-2.5-2.5-2.5S9.5 8.6 9.5 10c0 .8.4 1.6 1 2l-3.9 10h2.2l.5-1.5h5.4l.5 1.5h2.2l-3.9-10c.6-.4 1-1.2 1-2zm-4.2 8.5.7-2h2l.7 2h-3.4z',
  code: GLYPHS.code,
  leaf: 'M6.05 8.05a7.001 7.001 0 0 0-.02 9.88c1.47-3.4 4.09-6.24 7.36-7.93A15.952 15.952 0 0 0 8 19.32c2.6 1.23 5.8.78 7.95-1.37C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05z',
  gavel: 'M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z',
  megaphone: GLYPHS.megaphone,
  restaurant: 'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z',
  heart: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
};

// Industrie -> { hue, glyph }. De sleutels zijn EXACT de labels uit
// lib/industries.mjs: die lijst is de woordenlijst, deze tabel alleen het beeld.
export const INDUSTRY_META = {
  'Finance': { hue: '#00875A', glyph: 'coins3' },
  'Verzekeren': { hue: '#880E4F', glyph: 'umbrella' },
  'Zorg': { hue: '#E53935', glyph: 'hospital' },
  'Farma en life sciences': { hue: '#00ACC1', glyph: 'medication' },
  'Overheid': { hue: '#1A237E', glyph: 'bank' },
  'Defensie en veiligheid': { hue: '#37474F', glyph: 'shieldcross' },
  'Energie en utilities': { hue: '#FDD835', glyph: 'bolt' },
  'Logistiek en transport': { hue: '#F4511E', glyph: 'truck' },
  'Luchtvaart': { hue: '#039BE5', glyph: 'flight' },
  'Maritiem': { hue: '#0277BD', glyph: 'boat' },
  'Automotive': { hue: '#546E7A', glyph: 'car' },
  'Industrie en maakindustrie': { hue: '#6D4C41', glyph: 'factory' },
  'Hightech': { hue: '#7C4DFF', glyph: 'memory' },
  'Retail en e-commerce': { hue: '#FB8C00', glyph: 'cart' },
  'Bouw en vastgoed': { hue: '#8D6E63', glyph: 'apartment' },
  'Onderwijs': { hue: '#3949AB', glyph: 'school' },
  'Telecom': { hue: '#00BFA5', glyph: 'celltower' },
  'IT en software': { hue: '#455A64', glyph: 'code' },
  'Agro en food': { hue: '#7CB342', glyph: 'leaf' },
  'Juridisch': { hue: '#5D4037', glyph: 'gavel' },
  'Media en marketing': { hue: '#EC407A', glyph: 'megaphone' },
  'Horeca en leisure': { hue: '#FF6D00', glyph: 'restaurant' },
  'Non-profit': { hue: '#D81B60', glyph: 'heart' },
};

// marketIcon() returns markup for use in image-only contexts. Escape every
// database-backed label before it enters the SVG so it can never add elements
// or attributes to that markup.
function escapeXml(value) {
  return String(value ?? '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&apos;',
    '"': '&quot;',
  })[character]);
}

// Witte tegel (31x31 binnen 32-viewBox, hairline rand) met de glyph gecentreerd.
// Schaduwlaag (meta.shade): dezelfde glyph nogmaals, zwart op 28%, geknipt op de
// rechterhelft van het 24-vlak. Geeft een licht ruimtelijk effect zonder een
// tweede kleur per markt; de clipPath-id is per SVG uniek genoeg omdat het
// icoon als losse data-URI in een <img> leeft en nooit in de pagina-DOM.
function shadeLayer(d) {
  return `<defs><clipPath id="s"><rect x="12" y="0" width="12" height="24"/></clipPath></defs>` +
    `<path d="${d}" fill="#000" fill-opacity="0.28" clip-path="url(#s)"/>`;
}

// Een glyph is OF een pad (de gewone vorm, een vlak in de hue van markt of
// industrie) OF een lijst lagen die in volgorde over elkaar komen. Een laag
// vult (fill 'hue' = de kleur van dit icoon, elke andere waarde is die kleur
// letterlijk) of streept (stroke + sw). Alleen de twee tweekleurige
// industrieglyphs gebruiken de lagenvorm; alles daarbuiten blijft een pad.
function glyphBody(glyph, hue) {
  if (!Array.isArray(glyph)) return `<path d="${glyph}" fill="${hue}"/>`;
  return glyph.map((laag) => {
    const vul = laag.fill === 'hue' ? hue : (laag.fill || 'none');
    const lijn = laag.stroke === 'hue' ? hue : laag.stroke;
    return `<path d="${laag.d}" fill="${vul}"` +
      (lijn ? ` stroke="${lijn}" stroke-width="${laag.sw ?? 1}" stroke-linecap="round" stroke-linejoin="round"` : '') +
      `/>`;
  }).join('');
}

function tile(glyph, hue, size, safeLabel, shade = false) {
  const d = glyph || GLYPHS.package;
  // De schaduwlaag knipt EEN pad; een gelaagde glyph draagt zijn tweede kleur al
  // en vraagt er niet om, dus die combinatie bestaat bewust niet.
  const kanSchaduw = shade && typeof d === 'string';
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 32 32" fill="none" role="img" aria-label="${safeLabel}"><title>${safeLabel}</title>` +
    `<rect x="0.5" y="0.5" width="31" height="31" fill="${PALETTE.tile}" stroke="${PALETTE.tileBorder}" stroke-width="1"/>` +
    `<g transform="translate(4 4)">${glyphBody(d, hue)}${kanSchaduw ? shadeLayer(d) : ''}</g></svg>`;
}

/** Markt-icoon (witte tegel + gevulde glyph) als SVG-string. */
export function marketIcon(name, opts = {}) {
  const meta = MARKET_META[name] || { hue: PALETTE.slate, glyph: 'package' };
  const { hue = meta.hue, size = 32 } = opts;
  return tile(GLYPHS[meta.glyph], hue, size, escapeXml(name), !!meta.shade);
}

/**
 * ALLEEN de gevulde glyph, zonder tegel en zonder rand, als SVG-string. Voor
 * plekken waar het omhullende vakje zijn eigen wit en hairline al tekent: de
 * onderscheidingsbalk van het recordvenster zet de markt in een 20-badge, en
 * een tegel binnen die badge leest als een dubbel kader. Zelfde fallback
 * (slate + package) en dezelfde XML-escaping als marketIcon: markt-namen komen
 * uit de database en mogen nooit als markup binnenkomen.
 */
export function marketGlyph(name, opts = {}) {
  const meta = MARKET_META[name] || { hue: PALETTE.slate, glyph: 'package' };
  const { hue = meta.hue, size = 14 } = opts;
  const safeLabel = escapeXml(name);
  const d = GLYPHS[meta.glyph] || GLYPHS.package;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" role="img" aria-label="${safeLabel}"><title>${safeLabel}</title>` +
    glyphBody(d, hue) + (meta.shade ? shadeLayer(d) : '') + `</svg>`;
}

/**
 * Industrie-icoon (witte tegel + gevulde glyph) als SVG-string. Tweeling van
 * marketIcon over INDUSTRY_META, dus markt- en industrietegels staan naast
 * elkaar in precies hetzelfde recept. Een label buiten de woordenlijst valt
 * terug op de neutrale doos, net als een onbekende markt.
 */
export function industryIcon(name, opts = {}) {
  const meta = INDUSTRY_META[name] || { hue: PALETTE.slate, glyph: 'package' };
  const { hue = meta.hue, size = 32 } = opts;
  return tile(INDUSTRY_GLYPHS[meta.glyph] || GLYPHS[meta.glyph], hue, size, escapeXml(name));
}

/**
 * ALLEEN de gevulde industrieglyph, zonder tegel: voor de pil die zijn eigen
 * wit en rand al tekent. Zelfde terugval en zelfde XML-escaping als
 * industryIcon; de labels komen uit de database en mogen nooit als markup
 * binnenkomen.
 */
export function industryGlyph(name, opts = {}) {
  const meta = INDUSTRY_META[name] || { hue: PALETTE.slate, glyph: 'package' };
  const { hue = meta.hue, size = 14 } = opts;
  const safeLabel = escapeXml(name);
  const d = INDUSTRY_GLYPHS[meta.glyph] || GLYPHS[meta.glyph] || GLYPHS.package;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" role="img" aria-label="${safeLabel}"><title>${safeLabel}</title>` +
    glyphBody(d, hue) + `</svg>`;
}

// Retained slots delen de Markten-tegelstijl: zelfde witte tegel, gevulde
// glyph met een eigen toestandskleur:
//   beschikbaar (voorraad op de plank) -> inventory, amber
//   in gebruik  (loopt in een search)  -> briefcase, blauw
//   afgerond    (search geleverd)      -> shield, groen
const RETAINER_META = {
  available: { hue: '#FFB300', glyph: 'inventory' },
  inUse: { hue: '#2962FF', glyph: 'briefcase' },
  completed: { hue: '#43A047', glyph: 'shield' },
};

/** Retainer-icoon per toestand als SVG-string. */
export function retainerIcon(opts = {}) {
  const { state, size = 32, label } = opts;
  // state kan uit de database komen (slot-rij): nooit als sleutel vertrouwen,
  // altijd terugvallen op 'available' en het label XML-escapen voor het de markup in gaat.
  const meta = RETAINER_META[state] || RETAINER_META.available;
  const hue = opts.hue || meta.hue;
  return tile(GLYPHS[meta.glyph], hue, size, escapeXml(label ?? 'Retainer'));
}

// De merktekens van het bord Nieuw & Hot op de kantoormuur, zalm (#fab0ac) op
// de donkere heroborden. Geen tegel: het teken staat achter de vacaturetitel,
// niet ernaast als markticoon. Twee soorten:
//   nieuw -> Material Symbols add_circle, de plus in een cirkel, gevuld;
//            NieuwHotIcon in lib.js tekent hetzelfde pad in HV2.blue
//            (eigenaarsbesluit 12 september 2026, in de plaats van het
//            new_releases-zegel van 3 september, dat de ster verving);
//   hot   -> de gevulde trending-glyph, dezelfde als NieuwHotIcon, label Prioriteit.
// Het pad staat hier EEN keer en lib.js importeert het, zodat muur en app nooit
// uit de pas lopen. Let op: Material-viewBox 0 -960 960 960, niet 0 0 24 24.
export const NH_NEW_PATH = 'm440-280h80v-160h160v-80H520v-160h-80v160H280v80h160v160ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z';
export const NH_NEW_VIEWBOX = '0 -960 960 960';

// Het takglyph van ELK proces (eigenaarsbesluit 4 oktober 2026): EntityIcon entity="process", RailIcon
// 'processen', de lege processtaat, de KPI-kolom Processen en de banner. Vier
// paden in 24x24, lijn, currentColor. Staat hier EEN keer omdat
// lib/banner-templates.mjs (server, geen React) hem ook tekent;
// components/HomeV2/lib.js re-exporteert hem. Ratchet: lib/design-procesglyph.test.mjs.
export const BRANCH_PATHS = ['M6 3V15', 'M15 6a3 3 0 1 0 6 0a3 3 0 1 0-6 0', 'M3 18a3 3 0 1 0 6 0a3 3 0 1 0-6 0', 'M18 9a9 9 0 0 1-9 9'];
const NH_MARK_LABEL = { nieuw: 'Nieuw', hot: 'Prioriteit' };

/** Merkteken nieuw of hot als SVG-string (24-viewBox, geen tegel). */
export function nhMarkIcon(kind, opts = {}) {
  const { size = 64, color = '#fab0ac' } = opts;
  // kind is een vaste sleutel uit eigen code, maar onbekend valt terug op 'nieuw'
  // in plaats van een leeg plaatje op de muur te zetten.
  const k = NH_MARK_LABEL[kind] ? kind : 'nieuw';
  const label = NH_MARK_LABEL[k];
  const body = k === 'hot'
    ? `<path d="${GLYPHS.trending}" fill="${color}"/>`
    : `<svg x="0" y="0" width="24" height="24" viewBox="${NH_NEW_VIEWBOX}"><path d="${NH_NEW_PATH}" fill="${color}"/></svg>`;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" role="img" aria-label="${label}"><title>${label}</title>${body}</svg>`;
}

// Ordered keyword rules ported from lib/market-infer.mjs (FIRST MATCH WINS), so a
// free-text title / het externe systeem token maps to the same market the app would pick.
const RULES = [
  ['Legacy', [/cobol|mainframe|jcl|rexx|as\/?400|rpg\b/]],
  ['Executive', [/^(?!.*(sales|commerci|account|business develop|art director|creative director|\bcco\b))(?=.*(\bc[eftio]o\b|\bchro\b|head of it|\bdirect(or|eur)\b|managing partner|competence lead|practice lead|unit ?manager))/]],
  ['.NET', [/\.net\b|\bdotnet\b|\bc#|c sharp|asp\.net|blazor|xamarin|vb\.net/]],
  ['Java', [/\bjava\b|\bkotlin\b|spring\s?boot|\bspring\b|\bjvm\b|quarkus|jakarta|hibernate|\bscala\b/]],
  ['PHP', [/\bphp\b|laravel|symfony|drupal|wordpress/]],
  ['Front-end', [/front.?end|\bfe\b|\breact\b|angular|\bvue\b|svelte|typescript|javascript|ux\/ui|\bux\b|\bui\b|\bmobile\b|\bios\b|android|flutter/]],
  ['Embedded', [/embedded|\bc\+\+|\brtos\b|firmware|\bvhdl\b|\bfpga\b/]],
  ['Security', [/security|\bsoc\b|\bciso\b|pentest|\biam\b|cyber|\bgrc\b|\bsiem\b/]],
  ['Business Intelligence', [/business intelligence|\bbi\b|power bi|tableau|qlik|looker|\bdax\b|\bssrs\b|\bssis\b|data ?warehouse|\bdwh\b/]],
  ['Data', [/\bdata\b|\betl\b|analytics|machine learning|\bml\b|\bai\b|data scien|data engineer|databricks|snowflake|\bspark\b|\bpython\b|\bsql\b|\boracle\b|\bdba\b/]],
  ['Cloud', [/\bcloud\b|\baws\b|\bazure\b|\bgcp\b|devops|kubernetes|\bk8s\b|terraform|platform engineer|\bsre\b|site reliability|\blinux\b|infrastructure|network engineer|systeembeheer|\bnetwerk/]],
  ['Testing', [/\btest|\bqa\b|quality assurance|\btester\b|\bsdet\b|cypress|selenium|automation engineer/]],
  ['ERP', [/\bsap\b|\berp\b|dynamics|mendix|outsystems|\bafas\b|servicenow|salesforce|integratie/]],
  ['Agile', [/business anal|\bba\b|product owner|\bpo\b|scrum|\bagile\b|\bsafe\b|\bpmo\b|\bpm\b|project manager|business consultant/]],
  ['Techniek', [/techniek|werktuigbouw|werktuig|civiele|\bgww\b|bouwkunde|\bbouw\b|installatie|energietechn|elektro|\bbim\b|\bplm\b|\bk&l\b|\bhvac\b|maintenance engineer/]],
  ['Architectuur', [/architect|\btogaf\b|archimate/]],
  ['Accounting', [/accountan|\baccounting\b|\bsamenstel|\bfiscaal|salarisadministratie|loonadministratie|\bgrootboek|\baudit|\btax\b|\bpayroll\b/]],
  ['Controlling', [/controller|\bcontrolling\b|business control|financial control/]],
  ['Finance', [/\bfinanc|\bfp&a\b|\btreasur|corporate finance|financial reporting|\bifrs\b/]],
  ['Sales', [/\bsales\b|business develop|account manager|account director|\bcco\b|\bcommerci|\baccount executive\b|\binkoop\b|\bmarketing\b|bid manager/]],
  ['Contracting', [/\binterim\b|\bzzp\b|freelance|\bcontract/]],
];

/** Map a free-text title / market token to a canonical market (or null). */
export function classifyMarket(text) {
  const t = String(text || '').toLowerCase();
  if (!t.trim()) return null;
  const exact = MARKETS.find((m) => m.toLowerCase() === t.trim());
  if (exact) return exact;
  for (const [market, pats] of RULES) if (pats.some((p) => p.test(t))) return market;
  return null;
}

if (typeof window !== 'undefined') {
  window.PartnerbookIcons = { PALETTE, MARKETS, MARKET_META, marketIcon, marketGlyph, INDUSTRY_META, industryIcon, industryGlyph, retainerIcon, nhMarkIcon, classifyMarket };
}
